import React from 'react'
import {  Checkbox } from "antd";

const checkbox = () => {
    const onChange = (e) => {
        console.log(`checked = ${e.target.checked}`);
      };
  return (
    
    <div className="checkbox-wrap">
    <Checkbox className="checkbox" onChange={onChange}>
      Are you wish to save this card ?
    </Checkbox>
  </div>
  )
}

export default checkbox